import React from 'react'
import PropTypes from 'prop-types'

// Labelled text/number input with an optional prefix; `ariaLabel` when the label lives elsewhere.

const TextField = ({
  id,
  label,
  ariaLabel,
  type = 'text',
  value,
  onChange,
  onKeyDown,
  onBlur,
  placeholder,
  prefix,
  suffix,
  min,
  step,
  disabled = false,
  autoFocus = false,
  className = '',
}) => {
  if (process.env.NODE_ENV !== 'production' && !label && !ariaLabel) {
    // eslint-disable-next-line no-console
    console.warn(`gl TextField (${id}): needs a label or an ariaLabel`)
  }

  return (
    <div className={[ 'gl-field', className ].filter(Boolean).join(' ')}>
      {label && <label className="gl-field-label" htmlFor={id}>{label}</label>}
      <div className="gl-field-input-wrap">
        {prefix && <span className="gl-field-input-prefix" aria-hidden="true">{prefix}</span>}
        <input
          id={id}
          className="gl-field-input"
          type={type}
          value={value === null || value === undefined ? '' : value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          placeholder={placeholder}
          min={min}
          step={step}
          disabled={disabled}
          autoFocus={autoFocus}
          aria-label={label ? undefined : ariaLabel}
        />
        {suffix && <span className="gl-field-input-suffix" aria-hidden="true">{suffix}</span>}
      </div>
    </div>
  )
}

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  type: PropTypes.oneOf([ 'text', 'number', 'email', 'tel' ]),
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  // Used where a field saves on leaving it rather than on a submit
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  min: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  step: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
}

export default TextField
